import { useCallback, useEffect, useState } from 'react';
import api, { formatError } from '@/lib/api';
import { toast } from 'sonner';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SalesPersonsTab } from '@/components/sales/SalesPersonsTab';
import { ClientMappingTab } from '@/components/sales/ClientMappingTab';
import { CommissionsTab } from '@/components/sales/CommissionsTab';
import { ExamQuestionsTab } from '@/components/sales/ExamQuestionsTab';

export default function SalesAdminPage() {
  const [people, setPeople] = useState([]);
  const [clients, setClients] = useState([]);

  const reload = useCallback(() => {
    Promise.all([api.get('/sales/persons'), api.get('/sales/clients')])
      .then(([p, c]) => { setPeople(p.data); setClients(c.data); })
      .catch(err => toast.error(formatError(err.response?.data?.detail)));
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const unmapped = clients.filter(c => !c.sales_person_id).length;

  return (
    <div className="space-y-6" data-testid="sales-admin-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-brand-text-primary tracking-tight">Sales Team</h1>
        <p className="text-sm text-brand-text-secondary mt-1">Sales persons earn 5% of their clients&apos; net monthly profit, paid from the company share.</p>
      </div>
      <Tabs defaultValue="persons" className="space-y-4">
        <TabsList className="bg-brand-bg/50 border border-brand-border/50 rounded-lg p-0.5">
          <TabsTrigger value="persons" className="text-xs px-4" data-testid="tab-sales-persons">Sales Persons ({people.length})</TabsTrigger>
          <TabsTrigger value="mapping" className="text-xs px-4" data-testid="tab-client-mapping">Client Mapping ({unmapped} unmapped)</TabsTrigger>
          <TabsTrigger value="commissions" className="text-xs px-4" data-testid="tab-commissions">Commissions</TabsTrigger>
          <TabsTrigger value="exam" className="text-xs px-4" data-testid="tab-exam-questions">Exam Questions</TabsTrigger>
        </TabsList>
        <TabsContent value="persons"><SalesPersonsTab people={people} reload={reload} /></TabsContent>
        <TabsContent value="mapping"><ClientMappingTab clients={clients} people={people} reload={reload} /></TabsContent>
        <TabsContent value="commissions"><CommissionsTab onChange={reload} /></TabsContent>
        <TabsContent value="exam"><ExamQuestionsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
